import AppContent from '@/AppContent';
import React from 'react';

const Home: React.FC = () => {
    return <AppContent />;
};

export default Home;
